import script from "./InformationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationModal.vue?vue&type=script&setup=true&lang=ts"

import "./InformationModal.vue?vue&type=style&index=0&id=0deb45d2&lang=css"

const __exports__ = script;

export default __exports__